import axios from 'lib/axios'
export const showingMethods = {
  rently_standard: 'Rently standard',
  rently_safe_mode: 'Rently safe mode',
  upandup_identity_verified: 'Up&Up identity verified',
  adt_showing: 'ADT showing'
}
export type Promotion = {
  id: string
  token: string
  category: string
  frequency: string
  amount: string
  start_date: string
  end_date: string
  display_message: string
  canceled_at: string | null
}
export type ListingManagement = {
  editable: boolean
  ineligibility_message: string | null
  token: string
  listing: {
    active: boolean
    internal_status: string | null
    showing_type: string
    is_active: boolean
    earliest_tour_date: string | null
    earliest_move_in_date: string | null
  }
  promotions: { items: Promotion[]; page: number; per_page: number; total_count: number }
  history: Array<{
    client_key: string
    action: string
    recorded_at: string
    actor_name: string
    reason: string
  }>
}
export type ListingCommand = {
  action: 'listing_settings' | 'promotion_save' | 'promotion_end'
  client_key: string
  expected_token: string
  reason: string
  active?: boolean
  deactivation_acknowledged?: boolean
  showing_type?: string
  promotion?: Pick<Promotion, 'amount' | 'start_date' | 'end_date' | 'display_message'> & {
    id?: string
    token?: string
  }
  promotion_id?: string
  promotion_token?: string
}
const path = (id: string) => `/admin/vacancies/${encodeURIComponent(id)}/listing-management`
export const vacancyListingApi = {
  async read(id: string, page: number): Promise<ListingManagement> {
    return (await axios.get(path(id), { params: { page, per_page: 25 } })).data
  },
  async save(id: string, command: ListingCommand) {
    return (await axios.post(path(id) + '/actions', command)).data
  }
}
